export enum RewardSource {
  VOUCHER_REDEMPTION = 'VOUCHER_REDEMPTION',
  GOAL_ACHIEVEMENT = 'GOAL_ACHIEVEMENT',
}

export interface RewardTransaction {
  id: string;
  source: RewardSource;
  amount: number;
  currencyCode: string;
  description: string;
  createdAt: string;
}

export interface RewardsBalance {
  amount: number;
  currencyCode: string;
}

export interface RewardsSummary {
  balance: RewardsBalance;
  transactions: RewardTransaction[];
}

export interface VoucherRedeemRequest {
  voucherCode: string;
}

